import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { useDebounce } from "use-debounce";
import * as Yup from "yup";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { MANDATORY_FIELD } from "../../Components/constants/messages";
import ModalCustom from "../../Components/Modals/ModalCustom";
import {
  createFilterWhereStayRequest,
  getFiltersWhereStayRequest,
  updateFilterWhereStayRequest,
} from "../../store/filters/whereStay/actions";
import { getFilterWhereStayRequest } from "../../store/filters/whereStayDetails/actions";
import FiltersWhereStayForm from "./FiltersWhereStayForm";
import { FiltersWhereStayTable } from "./FiltersWhereStayTable";

const FiltersWhereStayList = () => {
  document.title = "Filtros onde ficar | Ecoguias - Admin Dashboard";

  const [modalAddFilter, setModalAddFilter] = useState(false);
  const [modalEditFilter, setModalEditFilter] = useState(false);
  const [idFilterWhereStay, setIdFilterWhereStay] = useState(null);

  const dispatch = useDispatch();

  const { loading, data } = useSelector((state) => state.FiltersWhereStay);
  const { loading: loadingDetails, data: dataDetails } = useSelector(
    (state) => state.FiltersWhereStayDetails
  );

  const [searchInput, setSearchInput] = useState("");
  const [value] = useDebounce(searchInput, 500);

  function closeModal() {
    return setModalAddFilter(false) || setModalEditFilter(false);
  }

  const filterWhereStay = useFormik({
    enableReinitialize: true,
    initialValues: Object.assign({
      nome: dataDetails && modalEditFilter ? dataDetails.nome : "",
    }),

    validationSchema: Yup.object({
      nome: Yup.string("O nome do filtro deve ser do tipo texto").required(
        MANDATORY_FIELD
      ),
    }),
    onSubmit: (values, { resetForm }) => {
      dispatch(createFilterWhereStayRequest({ values, resetForm, closeModal }));
    },
  });

  useEffect(() => {
    dispatch(getFiltersWhereStayRequest(value));
  }, [dispatch, value]);

  useEffect(() => {
    if (idFilterWhereStay && modalEditFilter) {
      dispatch(getFilterWhereStayRequest(idFilterWhereStay));
    }
  }, [dispatch, idFilterWhereStay, modalEditFilter]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Tabela de filtros onde ficar"
            pageTitle="Onde ficar"
          />
          <div className="d-flex justify-content-between pb-4 flex-wrap">
            <Input
              type="text"
              style={{ maxWidth: 250 }}
              className="form-control"
              placeholder="Pesquisar..."
              id="search-options"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button
              className="btn btn-primary"
              onClick={(event) => {
                event.preventDefault();
                setModalAddFilter(true);
              }}
            >
              Cadastrar
            </button>
          </div>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Filtros - Onde Ficar</h5>
                </CardHeader>

                <CardBody>
                  <FiltersWhereStayTable
                    style={{ width: "100%" }}
                    filters={data?.result ?? []}
                    loading={loading || loadingDetails}
                    idFilterWhereStay={idFilterWhereStay}
                    setIdFilterWhereStay={setIdFilterWhereStay}
                    showModalEdit={() => {
                      setModalEditFilter(true);
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ModalCustom
        title="Adicionar filtro para onde ficar"
        isOpen={modalAddFilter}
        onCancel={(event) => {
          event.preventDefault();
          setModalAddFilter(false);
        }}
        onClick={async (event) => {
          event.preventDefault();
          filterWhereStay.handleSubmit();
          return null;
        }}
      >
        <FiltersWhereStayForm form={filterWhereStay} />
      </ModalCustom>

      <ModalCustom
        title="Editar filtro de onde ficar"
        isOpen={modalEditFilter}
        onCancel={(event) => {
          event.preventDefault();
          setModalEditFilter(false);
          setIdFilterWhereStay(null);
        }}
        onClick={(event) => {
          event.preventDefault();
          dispatch(
            updateFilterWhereStayRequest({
              id: idFilterWhereStay,
              ...filterWhereStay,
              closeModal,
            })
          );

          setIdFilterWhereStay(null);
          return null;
        }}
      >
        <FiltersWhereStayForm form={filterWhereStay} />
      </ModalCustom>
    </React.Fragment>
  );
};

export default FiltersWhereStayList;
